import { memo } from "react";
import Chip from "@mui/material/Chip";
import type { BatchJobItemReview } from "../../../../lib/corpusApi";

const REVIEW_MAP: Record<
  BatchJobItemReview,
  { label: string; color: "default" | "success" | "warning" }
> = {
  open: { label: "Open", color: "warning" },
  applied: { label: "Revoked", color: "success" },
  dismissed: { label: "Dismissed", color: "default" },
};

export interface AdmissionReviewBadgeProps {
  review: BatchJobItemReview;
}

/** Chip rendering where a human review of an admission finding stands — "applied" reads as
 *  "Revoked", since applying an admission finding revokes the document. */
export const AdmissionReviewBadge = memo(function AdmissionReviewBadge({
  review,
}: AdmissionReviewBadgeProps) {
  const { label, color } = REVIEW_MAP[review];
  return <Chip label={label} color={color} size="small" />;
});
